/**
 * Shared frame-throttle interval for 360° model interactions.
 * 33 ms ~= 30 fps.
 */
export const MODEL_FRAME_INTERVAL_MS = 33
